<!DOCTYPE html>
<!--<head>
<meta name="viewport" content="width=device-width, initial-scale=1">
</head>
<ng-container *ngIf="user">
  <app-toolbar [title]="title"  [user]="user" [back]="true" [destination]="destination"></app-toolbar>
</ng-container> -->

<div class="column">
    <h2>Pazienti globali - Utenti che non hanno effettuato l'accesso per fasce d'età: RANGE PERSONALIZZATO</h2>
    <form [formGroup]="numberFormAge" (ngSubmit)="onSubmitAgeForm()">
      <h3>Seleziona la fascia d'età</h3>
      <label for="from">Da: </label>
      <input id="from" type="text" formControlName="from">
      <label for="to">A: </label>
      <input id="to" type="text" formControlName="to">
      <button mat-raised-button color="primary" style="margin-left:10px;" type="submit" [disabled]="!numberFormAge.valid">Carica</button>
    </form>
    <div style="display: inline-block" style="padding-left: 2vw; padding-top: 1vw">
      <div class = "chart-container">
        <canvas id = "myChartNeverLoggedAgeFromUser"></canvas> 
      </div>
    </div>

  </div>
